import * as React from 'react';

import { FieldProps, getIn } from 'formik';

const styles = require('./InputTextarea.scss');

export interface Props {
    label: string;
    placeholder: string;
}

export const FormikTextarea = ({ field, form: { errors, touched }, label, placeholder }: FieldProps & Props) => (
    <div className={styles.className}>
        <div className={styles.labelWrapper}>
            <label className={styles.label}>{label}</label>
        </div>

        <textarea className={styles.textare} {...field} value={field.value || undefined} placeholder={placeholder} />

        {
            /* @ts-ignore */
            getIn(errors, field.name) && getIn(touched, name) && <div className={styles.error}>{getIn(errors, field.name)}</div>
        }
    </div>
);

export default FormikTextarea;
